<template>
  <xl-tree-member-modal ref="xlTreeMember" :tree="departTree" @cb="setModulesItem($event, modulesItem)" :multipleDep="departExt == 1 ? false : true" :depart="modulesItem?.setting.fv?.departList" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll">
    <jw-input-tag v-model="modulesItem.fieldValue" :class="[isTask ? 'task-fields' : 'system-form-item-fields', isQuoteField ? 'ly-form-item-fields-disabled' : '']" :max-tag-count="3" readonly :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll" :placeholder="isQuoteField ? quoteFieldPlaceholder : modulesItem?.placeholder || ''">
      <template #tag="{ data }">
        <div class="tag-item" :style="{ background: setBg(data) }">
          {{ data?.label }}
        </div>
      </template>
      <template #suffix>
        <qfei-icon-add-one-outlined size="14" />
      </template>
    </jw-input-tag>
  </xl-tree-member-modal>
</template>

<script setup>
import { ref, inject, computed } from 'vue';
const emits = defineEmits(['cb']);
import { QfeiIconAddOneOutlined } from '@qfei-design/icons-vue';
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const quoteFieldPlaceholder = inject('fhFormFieldsParams')?.quoteFieldPlaceholder;
import useEditFields from '@/hooks/edit-field';
const { getRandomColor } = useEditFields();
const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  isTask: {
    type: Boolean,
    default: false
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});

const modulesItem = computed(() => props?.modules);

const departExt = computed(() => {
  return isQuoteField.value ? modulesItem.value?.setting?.business?.fieldExt : modulesItem.value?.setting?.fieldExt;
});

const setModulesItem = (ev) => {
  emits('personDepartCb', ev); //人员和部门
};

const setBg = (data) => {
  if (Array.isArray(modulesItem.value.fieldValue) && modulesItem.value.fieldValue.length) {
    const _index = modulesItem.value.fieldValue?.indexOf(data.label);
    if (_index !== -1) {
      return getRandomColor(_index);
    }
  }
  return getRandomColor(0);
};
</script>
<style scoped lang="less">
.tag-item {
  padding: 0 8px;
  border-radius: 4px;
}

.fh-update-fields .system-form-item-fields :deep(.arco-input-tag-tag) {
  background-color: transparent;
  border-color: transparent;
}

:deep(.arco-tag) {
  padding: 0;
  border-radius: 0;
}
</style>
